import { playlists } from "@/mocks/playlists";
import type { PlaylistItem } from "@/pages/home/types";
import SectionHeading from "@/pages/home/components/SectionHeading";

const data = playlists as PlaylistItem[];

const accentMap: Record<string, { bar: string; badge: string }> = {
  accent: { bar: "bg-accent-500", badge: "bg-accent-100 text-accent-800" },
  primary: { bar: "bg-primary-500", badge: "bg-primary-100 text-primary-700" },
  secondary: { bar: "bg-secondary-500", badge: "bg-secondary-100 text-secondary-900" },
};

export default function PlaylistsSection() {
  return (
    <section id="playlists" className="scroll-mt-20 border-y border-background-200/70 bg-background-100/60">
      <div className="mx-auto w-full max-w-6xl px-4 py-16 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="高分片单合集"
          title="没想好就看片单：按场景挑，比自己翻快得多"
          desc="片单是把高分作品按观看场景重新组合的清单。同样是高分，深夜独看和家人同看的氛围完全不同，按场景挑能少走很多弯路。"
        />

        <div className="grid grid-cols-1 gap-4 md:gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {data.map((pl) => {
            const tone = accentMap[pl.accent] ?? accentMap.primary;
            return (
              <article
                key={pl.id}
                className="flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50"
              >
                <div className={`h-1.5 w-full ${tone.bar}`}></div>
                <div className="flex flex-1 flex-col p-5">
                  <div className="flex items-start justify-between gap-3">
                    <h3 className="font-heading text-lg font-semibold text-foreground-950">{pl.name}</h3>
                    <span className={`shrink-0 rounded-full px-2.5 py-0.5 text-xs ${tone.badge}`}>
                      {pl.items.length} 部
                    </span>
                  </div>
                  <p className="mt-1 text-xs text-foreground-600">{pl.subtitle}</p>
                  <ul className="mt-4 flex flex-col gap-2.5">
                    {pl.items.map((it) => (
                      <li key={`${pl.id}-${it.title}`} className="flex items-start gap-3">
                        <i className="ri-play-circle-line mt-0.5 text-base text-primary-500"></i>
                        <span className="min-w-0">
                          <span className="block text-sm font-medium text-foreground-900">{it.title}</span>
                          <span className="block text-xs text-foreground-500">{it.note}</span>
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}